export default __webpack_public_path__ + "static/media/logo-indigo.477dc2c0.png";